(function ($) {
  const ctrls = Array.from(document.querySelectorAll(".addtl_results__control"));
  if (ctrls && ctrls.length) {
    ctrls.forEach(ctrl => {
      const results = ctrl.parentElement.querySelector(".addtl_results");
      ctrl.addEventListener("click", function () {
        results.style.maxHeight = results.scrollHeight + "px";
        ctrl.parentElement.removeChild(ctrl);
      });
    })
  }

  const formReset = document.querySelector("#searchreset");
  if (formReset) {
    formReset.addEventListener("click", function () {
      //console.log("Yo!");
    });
  }

  const $strategyBlocks = $(".hero__content .component-strategy");
  $strategyBlocks.remove();

  const $contentCards = $(".post__subsection-results [class*=col-][class*=-6]");
  for (let i = 4; i <= $contentCards.length; i += 4) {
    $card = $contentCards.eq(i - 1);

    if ($card) {
      $block = $strategyBlocks.eq(i / 4 - 1);
      if ($block) {
        $block.insertAfter($card);
      }
    }
  }
})(jQuery);
